import { useEffect } from 'react';
import { ACTING_TENANT_STORAGE_KEY } from '@/utils/actingTenant';

export function useActingTenantTabSync(): void {
  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key === ACTING_TENANT_STORAGE_KEY) window.location.reload();
    };
    window.addEventListener('storage', handleStorage);
    return () => {
      window.removeEventListener('storage', handleStorage);
    };
  }, []);
}
